import React from 'react';
import { Link } from 'react-router-dom';
import { COMPANY, SERVICES } from '../../data/site';

// Placeholder href for links whose destinations don't exist yet. Using
// "/" (vs. "#") keeps eslint-jsx-a11y happy and degrades gracefully —
// clicking lands on the homepage instead of jumping to top of current page.
const TODO = '/';

export default function Footer() {
  return (
    <footer className="footer">
      <div className="container">
        <div className="footer-grid">
          <div className="footer-brand">
            <h3>Voila <span style={{ color: 'var(--muted)' }}>Tech</span></h3>
            <p>{COMPANY.tagline} Built by a senior team that ships outcomes, not deliverables.</p>
            <div style={{ marginTop: 22 }}>
              <span className="chip"><span className="dot"></span>{COMPANY.status}</span>
            </div>
          </div>

          <div className="footer-col">
            <h4>Services</h4>
            <ul>
              {SERVICES.slice(0, 5).map((s) => (
                <li key={s.slug}><Link to={`/services#${s.slug}`}>{s.title.replace(/ &.*$/, '')}</Link></li>
              ))}
              <li><Link to="/services">All services</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>Company</h4>
            <ul>
              <li><Link to="/about">About</Link></li>
              <li><Link to="/work">Case studies</Link></li>
              <li><Link to="/about#process">Process</Link></li>
              <li><Link to="/contact">Contact</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>Resources</h4>
            <ul>
              <li><Link to={TODO}>Field notes</Link></li>
              <li><Link to={TODO}>Engineering</Link></li>
              <li><Link to={TODO}>AI playbook</Link></li>
              <li><Link to={TODO}>Open source</Link></li>
            </ul>
          </div>

          <div className="footer-col">
            <h4>Contact</h4>
            <ul>
              <li><a href={`mailto:${COMPANY.email}`}>{COMPANY.email}</a></li>
              {COMPANY.phones.map((p) => <li key={p}><a href={`tel:${p.replace(/\s/g, '')}`}>{p}</a></li>)}
              <li>{COMPANY.locations.join(' · ')}</li>
              {COMPANY.social.linkedin && (
                <li>
                  <a href={COMPANY.social.linkedin} target="_blank" rel="noopener noreferrer">
                    LinkedIn ↗
                  </a>
                </li>
              )}
            </ul>
          </div>
        </div>

        <div className="big-mark" aria-hidden="true">Voila Tech.</div>

        <div className="footer-bottom">
          <span>© {new Date().getFullYear()} Voila Tech. All rights reserved.</span>
          <span className="legal">
            <Link to={TODO}>Privacy</Link>
            <Link to={TODO}>Terms</Link>
            <Link to={TODO}>Cookies</Link>
            <Link to={TODO}>Security</Link>
          </span>
        </div>
      </div>
    </footer>
  );
}
